// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_2JJ","cls2":"TransactionalPricingModal-cls2_BmL TransactionalPricingModal-cls1_2JJ"};